import { c as _c } from "react/compiler-runtime";
import { toLowerCase } from "@opensea/utils";
import { parseAsStringLiteral, useQueryState } from "nuqs";
import { CollectionItemsAction } from "@/components/items/collection/types";
import { QUERY_PARAM_KEYS } from "./keys";
const parser = parseAsStringLiteral(CollectionItemsAction.map(v => toLowerCase(v)));
export function useItemActionQueryParam() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parser.withDefault("buy");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [action, setAction] = useQueryState(QUERY_PARAM_KEYS.action, t0);
  let t1;
  if ($[1] !== action || $[2] !== setAction) {
    t1 = {
      action,
      setAction
    };
    $[1] = action;
    $[2] = setAction;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}